export const businessForm = {
  name: '',
  address: '',
  postcode: '',
  city: '',
  country: '',
  country_code: '',
  email: '',
  phone: ''
}

export const rules = {
  name: [
    (v: any) => !!v || 'Name is required',
    (v: any) => v.length <= 255 || 'Name must be less than 255 characters',
    (v: any) => v.length >= 1 || 'Name must be greater than 1 character'
  ],
  address: [
    (v: any) => !!v || 'Address is required',
    (v: any) => v.length <= 255 || 'Name must be less than 255 characters',
    (v: any) => v.length >= 1 || 'Name must be greater than 1 character'
  ],
  postcode: [
    (v: any) => !!v || 'Postcode is required',
    (v: any) => v.length <= 255 || 'Name must be less than 255 characters',
    (v: any) => v.length >= 1 || 'Name must be greater than 1 character'
  ],
  city: [
    (v: any) => !!v || 'City is required',
    (v: any) => v.length <= 255 || 'Name must be less than 255 characters',
    (v: any) => v.length >= 1 || 'Name must be greater than 1 character'
  ],
  country: [
    (v: any) => !!v || 'Country is required',
    (v: any) => v.length <= 255 || 'Name must be less than 255 characters',
    (v: any) => v.length >= 1 || 'Name must be greater than 1 character'
  ],
  email: [
    (v: any) => !!v || 'Email is required',
    (v: any) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,255})+$/.test(v) || 'E-mail must be valid',
    (v: any) => v.length <= 255 || 'Email must be less than 255 characters',
  ],
  phone: [
    (v: any) => !!v || 'Phone is required',
    (v: any) => v.length <= 255 || 'Name must be less than 255 characters',
    (v: any) => v.length >= 1 || 'Name must be greater than 1 character'
  ],
}
